import AgendaViewBase from '../AgendaViewBase/AgendaViewBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../EmploymentFinder/EmploymentFinderHomeTypes";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";


class MyEmployments extends compose(AgendaViewBase<any>) {
	//templateString = template; // tandard verwenden

    calendarContainer: HTMLElement; // will be passed as a function parameter

    myICalsLink: HTMLLinkElement; // set in postCreate

    buttonClickTimeout: number = null;

    calendarIems_searchResult: Array<moreCoreCalendarItem> = null;

    itemClickDlg: MdsLax<InstanceType<typeof GenericDialog>>;


    employmentTable_formatterFunction: Function = lang.hitch(this,
        function (cell: StaticTable.StaticTableCell<any>) {
            let node = cell.contentnode;
            let entity = cell.entity;
            let colName = cell.name;
            let value = cell.value;
            switch (colName) {
                case "date":
                    let dateFrom = entity["date_start"];
                    let dateTo = entity["date_end"];

                    if (dateFrom.slice(5, 7) == dateTo.slice(5, 7) && dateFrom.slice(8, 10) == dateTo.slice(8, 10)) {
                        var sYear: string = dateFrom.slice(0, 4);
                        var sMonth: string = dateFrom.slice(5, 7);
                        var sDay: string = dateFrom.slice(8, 10);
                        var sHourFrom: string = dateFrom.slice(11, 13);
                        var sHourTo: string = dateTo.slice(11, 13);
                        var sMinuteFrom: string = dateFrom.slice(14, 16);
                        var sMinuteTo: string = dateTo.slice(14, 16);
                        node.innerHTML = `${sDay}.${sMonth}.${sYear}, ${sHourFrom}:${sMinuteFrom} - ${sHourTo}:${sMinuteTo}`
                    } else {
                        node.innerHTML = (this as any).convertISOStringDateToLocalString(dateFrom) + " - " + (this as any).convertISOStringDateToLocalString(dateTo)
                    }
                    break;
            default:
                node.innerHTML = value;
        }
        });

    initAgendaView() {
        //this._layouts = this.tableLayouts_Bookings;
        
        this.setupAgendaView(
            "MyEmployments/GetFilterpanelOptions",
            "MyEmployments/GetEmploymentList",
            lang.hitch(this, this.openDetailView),
            lang.hitch(this, this.employmentTable_formatterFunction),
            null
        );
    }

    

    private _setUserDisplayname(name: string) {
        if (name) {
            //this.headingEmployeeName.innerHTML = " - " + name;
        }
    }

    openDetailView(item) { // TODO: dive into dojo for the Item Typings
        item = item["rowGroup"].entity.ref_ev_booking
        let data= {
            ClassName: item.Classname,
            EntityId: item.ID
        }

        let requestParams = {
            "jsonData": JSON.stringify(data)
        };


        this.RequestManager.post(
            window.appRoot + "Calendar/GetItemDetails",
            requestParams,
            lang.hitch(this, this._onGetItemData_Response),
            lang.hitch(this, this._onGetItemData_Error)
        );
        this.itemClickDlg = new GenericDialog();
        this.itemClickDlg.destroyOnClose = true;
        this.itemClickDlg.set("header", item.gDisp_web);
        //dlg.set("content", sContentText );
        this.itemClickDlg.set("closeBtn", true);
        this.itemClickDlg._setTopCloseBtnAttr(true);
        this.itemClickDlg.closeOnEscape = true;
        this.UiModder.domStyle.set(this.itemClickDlg.textNode, "min-height", "100px");
        this.StandbyStart(this.itemClickDlg.textNode);
        this.itemClickDlg.show();

    }
    _onGetItemData_Response(response: string | object): void {

        this.StandbyStop();

        let domConstruct = this.UiModder.domConstruct;
        let domAttr = this.UiModder.domAttr;

        if (typeof (response) == "object") {

            let isHTML: boolean = false;
            let obj = <any>response;

            let text = obj.content;

            if (obj.isHTMLdetailtext) {
                isHTML = true;
                let div = domConstruct.create("div", { "className": "itemDetailHTML" });
                domAttr.set(div, "innerHTML", obj.content);
                text = div.outerHTML;
            }

            else if (obj._propertyMap) {
                let detailviewPropertymap = obj._propertyMap;

                let table = this.UiModder.domConstruct.create("TABLE", {
                    style: {

                    },
                    className: "webcalenderRoot detailviewTable"

                });

                for (let attrObj of detailviewPropertymap) { // {path: string, translation: string}

                    let row = this.UiModder.domConstruct.create("TR", {
                        className: "detailviewRow"
                    }, table);

                    let label = attrObj.label;
                    if (label && label != "") {
                        let translation = this.translations[label];
                        if (translation) {
                            label = translation;
                        }
                    }

                    if (label && label != "") {
                        let tdLabel = this.UiModder.domConstruct.create("TD", {
                            innerHTML: label,
                            className: "detailviewLabel"
                        }, row);
                    }

                    let entityAttrValue = this.PitHelper.getEntityAttributeValue(response, attrObj.propertyname, "json");

                    if (attrObj.propertyname == "date_start" || attrObj.propertyname == "date_end") entityAttrValue = this._convertISODateStringToLocalDateString(entityAttrValue);

                    let tdValue: HTMLTableColElement = <HTMLTableColElement>this.UiModder.domConstruct.create("TD", {
                        innerHTML: entityAttrValue,
                        className: "detailviewContent"
                    }, row);

                    if (!label) {
                        this.UiModder.domAttr.set(tdValue, "colspan", "2");
                    }
                }

                if (response["cast"].length > 0) {
                    let row = this.UiModder.domConstruct.create("TR", {
                        className: "detailviewRow"
                    }, table);
                    let label = "Besetzung"
                    if (label && label != "") {
                        this.UiModder.domConstruct.create("TD", {
                            innerHTML: label,
                            className: "detailviewLabel"
                        }, row);
                    }

                    let tdValue: string = "";
                    let index = 1;
                    for (let castRow of response["cast"]) {
                        tdValue += castRow.c_cast_address + (castRow.c_cast_perfomer ? "(" + castRow.c_cast_perfomer + ")" : "");
                        if (index != response["cast"].length) {
                            tdValue += ", ";
                        }
                        index++;
                    }

                    this.UiModder.domConstruct.create("TD", {
                        innerHTML: tdValue,
                        className: "detailviewContent"
                    }, row);
                }

                if (response["program"].length > 0) {
                    let row = this.UiModder.domConstruct.create("TR", {
                        className: "detailviewRow"
                    }, table);
                    let label = "Programm"
                    if (label && label != "") {
                        this.UiModder.domConstruct.create("TD", {
                            innerHTML: label,
                            className: "detailviewLabel"
                        }, row);
                    }

                    let tdValue: string = "";
                    let index = 1;
                    for (let programRow of response["program"]) {
                        tdValue += programRow.c_opus + (programRow.c_composer_author ? "(" + programRow.c_composer_author + ")" : "");
                        if (index != response["program"].length) {
                            tdValue += ", ";
                        }
                        index++;
                    }

                    this.UiModder.domConstruct.create("TD", {
                        innerHTML: tdValue,
                        className: "detailviewContent"
                    }, row);
                }

                isHTML = true;
                text = table.outerHTML;
            }


            if (!isHTML) {
                let pre = domConstruct.create("pre", { "className": "itemDetailText" });
                domAttr.set(pre, "innerHTML", response);
                text = pre.outerHTML;
            }


            this.itemClickDlg._setContentAttr(text);
        }

        else {
            this.itemClickDlg._setContentAttr(response);

        }

    }

    _onGetItemData_Error(Error: any) {
        alert("Error loading item details: " + Error.Message);
        //this.publishToastMessage("Error loading item details", toasterIcons.error, 10000, Error.Message);
        //this.itemClickDlg.close(); // ? gut oder nicht so?
        this.itemClickDlg._setContentAttr(Error.Message);
        this.itemClickDlg._setHeaderAttr("Error loading item details");
        this.StandbyStop();
    }

    _convertISODateStringToLocalDateString(isoDate: string): string {
        var sYear: string = isoDate.slice(0, 4);
        var sMonth: string = isoDate.slice(5, 7);
        var sDay: string = isoDate.slice(8, 10);
        var sHour: string = isoDate.slice(11, 13);
        var sMinute: string = isoDate.slice(14, 16);
        return `${sDay}.${sMonth}.${sYear}, ${sHour}:${sMinute}`;
    }

    _onAgendaViewConfigSet(agendaView) {
        agendaView.datePicker.setupStyles("1rem", "1em", "0.95em", "25px", 1.2, 1.8);
    }


    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.initAgendaView();
        //this.UiModder.domAttr.set(this.myICalsLink, "href", window.appRoot + "ICalViewer/List");

        this.getCurrentUserDisplayName(lang.hitch(this, this._setUserDisplayname));

        this.setTitles(this.translations["MyEmployments_MainTitle"], this.translations["MyEmployments_Title"]);
        
        
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        //this.agendaView.datePicker.setupStyles("1rem", "1em", "0.95em", "25px", 1.2, 1.8);
    }
}

export default mdsWidget(MyEmployments);